// src/api/profile/profile.ts
import { api } from "../api";
import type { Profile } from "./profile.types";
import { trackEvent } from "../../utils/analytics";

export const profileApi = {
    get: async (): Promise<Profile> => {
        const response = await api.get("/profiles/me");
        return response.data;
    },

    getMe: async (): Promise<Profile> => {
        const { data } = await api.get("/profiles/me");
        return data;
    },

    updateMe: async (profileData: any) => {
        const { data } = await api.put("/profiles/me", profileData);
        return data;
    },

    deleteMe: async () => {
        const { data } = await api.delete("/profiles/me");
        trackEvent('account_deleted');
        return data;
    },

    exportData: async (): Promise<Blob> => {
        const response = await api.get("/profiles/me/export", {
            responseType: "blob",
        });
        // On iOS Capacitor, axios may return a string instead of a Blob
        const data = response.data;
        if (data instanceof Blob) return data;
        return new Blob([data], { type: "application/zip" });
    },

    uploadPhoto: async (file: File) => {
        const formData = new FormData();
        formData.append("file", file);
        const { data } = await api.post("/profiles/me/photo", formData);
        return data;
    },

    // ✅ fetch avatar as blob (Authorization header will be attached by interceptor)
    getAvatarBlob: async (userId: string) => {
        const res = await api.get(`/profiles/avatar/${userId}`, {
            responseType: "blob",
            // optional: avoid cached “old” images
            params: { t: Math.floor(Date.now() / 1000) },
        });
        return res.data as Blob;
    },
};
